import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n';
import languages from 'common/languages';
import { get } from 'lodash';

//import images
// import avatar1 from '../../assets/images/users/avatar-1.jpg';
import { formatDate } from 'utils/common/Time';
import { RootState } from 'slices';
import { removeCookie } from 'services/helpers/cookieHelper';
import { postLogout } from 'services/authService';
import { useDispatch } from 'react-redux';
import { apiError, logoutUserSuccess } from 'slices/auth/login/reducer';
import { appendPathToClientUrl } from 'services/helpers/resolveApiBaseUrl';
import { setLanguageCookie } from 'utils/common/languageCookie';

const ProfileDropdown = ({
  navHeight = '48px',
  trigMarginRight = '',
}: {
  navHeight?: string;
  trigMarginRight?: string;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // const profiledropdownData = createSelector(
  //   (state: any) => state.Profile,
  //   (user) => user.user
  // );
  // // Inside your component
  // const user = useSelector(profiledropdownData);

  const infoState = useSelector((state: RootState) => state.Info);
  const { user, isUserLoaded } = infoState;

  const [userName, setUserName] = useState('Admin');

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);

  const [isLanguageCollapsed, setIsLanguageCollapsed] = useState(false);
  const [selectedLang, setSelectedLang] = useState('');

  const [ExpireDate, setExpireDate] = useState('');
  const MapLang = useMemo(
    () => ({
      th: 'ภาษาไทย',
      en: 'English',
      zh: '中文',
      my: 'မြန်မာ',
      lo: 'ລາວ',
    }),
    []
  );

  useEffect(() => {
    if (user.username && isUserLoaded) {
      //   const obj: any = JSON.parse(authUSer);

      setUserName(
        user.username
        // process.env.REACT_APP_DEFAULTAUTH === "fake" ? obj.username === undefined ? user.first_name ? user.first_name : obj.data.first_name : "Admin" || "Admin" :
        // process.env.REACT_APP_DEFAULTAUTH === "firebase" ? obj.email && obj.email : "Admin"
      );
    }
  }, [userName, isUserLoaded, user]);

  useEffect(() => {
    const currentLanguage = localStorage.getItem('I18N_LANGUAGE');
    setSelectedLang(currentLanguage || 'en');
  }, []);

  useEffect(() => {
    if (user.expire_date && isUserLoaded) {
      setExpireDate(formatDate(user.expire_date));
    }
  }, [isUserLoaded, user]);

  const changeLanguageAction = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('I18N_LANGUAGE', lang);
    setLanguageCookie(lang);
    setSelectedLang(lang);
  };

  const toggleLanguageCollapse = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    setIsLanguageCollapsed(!isLanguageCollapsed);
  };

  //Dropdown Toggle
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };
  const handleLogout = useCallback(async () => {
    try {
      removeCookie('user');
      removeCookie('store_name');
      removeCookie('refreshToken');
      removeCookie('access_token');

      await postLogout();
      dispatch(logoutUserSuccess(true));

      const url = sessionStorage.getItem('url');
      const logoutUrl = appendPathToClientUrl(
        process.env.REACT_APP_POS2U_LOGOUT_URL,
        url || ''
      );
      if (process.env.NODE_ENV === 'development') {
        window.location.href = '/';
      } else {
        window.location.href = logoutUrl;
      }
    } catch (error) {
      dispatch(apiError(error));
    }
  }, [dispatch]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user px-0 mx-0"
        style={{ height: navHeight }}
      >
        <DropdownToggle
          tag="button"
          type="button"
          className="btn d-flex align-itmes-center px-0 mx-0"
          style={{ height: navHeight }}
          onMouseEnter={() => setIsProfileDropdown(true)}
        >
          <span className="d-flex align-items-center">
            {/* <img
              className="rounded-circle header-profile-user"
              src={avatar1}
              alt="Header Avatar"
            /> */}
            <div className="p-0">
              <i
                className="ri-account-circle-line text-muted fs-50 align-middle me-1 rounded-circle header-profile-user"
                style={{ fontSize: '2rem' }}
              ></i>
            </div>

            <span className="text-start ms-xl-2 p-0">
              <span
                className="d-none d-xl-inline-block fw-medium user-name-text"
                style={{
                  fontWeight: 'bold',
                  color: 'white',
                }}
              >
                {' '}
                {userName || ''}
              </span>
              <span className="mx-1 d-none d-xl-inline-block text-muted">
                <i className="bx bx-caret-down"></i>
              </span>
            </span>
            {/* <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {' '}
                {userName || 'Admin'}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                Founder
              </span>
            </span> */}
          </span>
        </DropdownToggle>
        <DropdownMenu
          className="dropdown-menu-end"
          style={{ minWidth: '250px', marginRight: trigMarginRight }}
          onMouseLeave={() => setIsProfileDropdown(false)}
        >
          <div className="text-center p-0">
            <i className="bx bx-time text-muted fs-16 align-middle me-1"></i>{' '}
            {t('ExpireDate')}
            <br />
            {ExpireDate}
            <br />
            <br />
            <h6>
              <strong>{userName}</strong>
            </h6>
            {/* <span style={{ fontSize: '0.8rem', fontWeight: 'bold' }}>
              {userName}
            </span> */}
          </div>

          {/* <DropdownItem className="p-0">
            <Link to="/user-info" className="dropdown-item">
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profile</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/apps-chat" className="dropdown-item">
              <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Messages</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to={'#'} className="dropdown-item">
              <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Taskboard</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/pages-faqs" className="dropdown-item">
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Help</span>
            </Link>
          </DropdownItem> */}
          <div className="dropdown-divider"></div>
          <div className="text-center p-0">
            <h6>Support Code:</h6>
            Line ID @pos2u <br />
            โทร. 02-096-2298 กด 3 <br />
            จันทร์-ศุกร์ 09:00-18:00
          </div>

          <div className="dropdown-divider"></div>
          {/* <DropdownItem className="p-0">
            <Link to="/pages-profile" className="dropdown-item">
              <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">
                Balance : <b>$5971.67</b>
              </span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/pages-profile-settings" className="dropdown-item">
              <span className="badge bg-success-subtle text-success mt-1 float-end">
                New
              </span>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Settings</span>
            </Link>
          </DropdownItem>
          <DropdownItem className="p-0">
            <Link to="/auth-lockscreen-basic" className="dropdown-item">
              <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">Lock screen</span>
            </Link>
          </DropdownItem> */}
          {/* Language Collapse Toggle */}
          <DropdownItem
            className="p-0"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <span
              onClick={(e) => toggleLanguageCollapse(e)}
              className="dropdown-item cursor-pointer d-flex align-items-center"
            >
              {/* <img
                src={get(languages, `${selectedLang}.flag`)}
                alt="Selected Language"
                height="20"
                className="me-2 rounded"
              /> */}
              <i className="bx bx-globe text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">
                {MapLang[selectedLang as keyof typeof MapLang]}
              </span>
              <i
                className={`mdi ${
                  isLanguageCollapsed ? 'mdi-chevron-up' : 'mdi-chevron-down'
                } ms-auto`}
              ></i>
            </span>
          </DropdownItem>

          {/* Collapsible Language Menu */}
          {isLanguageCollapsed && (
            <div className="language-collapse px-3 py-2">
              {Object.keys(languages).map((key) => (
                <DropdownItem
                  key={key}
                  onClick={() => changeLanguageAction(key)}
                  className={`notify-item ${
                    selectedLang === key ? 'active' : ''
                  }`}
                >
                  <img
                    src={get(languages, `${key}.flag`)}
                    alt={key}
                    className="me-2 rounded"
                    height="18"
                  />
                  <span className="align-middle">
                    {/* {get(languages, `${key}.label`)} */}
                    {MapLang[key as keyof typeof MapLang]}
                  </span>
                </DropdownItem>
              ))}
            </div>
          )}

          <DropdownItem className="p-0">
            <Link
              to="https://www.pos2u.com/wp-content/uploads/2018/03/USER-MANUAL-POS2U.pdf"
              target="_blank"
              className="dropdown-item"
            >
              <i className="bx bx-book text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle">{t('UserManual')}</span>
            </Link>
          </DropdownItem>

          <DropdownItem className="p-0">
            <Link
              to="/#"
              className="dropdown-item"
              onClick={() => {
                handleLogout();
              }}
            >
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{' '}
              <span className="align-middle" data-key="t-logout">
                Logout
              </span>
            </Link>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileDropdown;
